"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPolyfill = void 0;
function shouldPolyfill() {
    return !('supportedValuesOf' in Intl);
}
exports.shouldPolyfill = shouldPolyfill;
